import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLandslip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M3 4c.825.372 1.538.968 2.088 1.606.17-.31.474-.515.822-.515.536 0 .97.489.97 1.091l-.001.056c.358.08.689.251.97.49 0-.904.652-1.637 1.456-1.637.803 0 1.455.733 1.455 1.637 0 .463-.171.88-.445 1.178.209.06.42.128.633.2.248-.497.723-.833 1.266-.833.804 0 1.455.733 1.455 1.637 0 .122-.011.24-.034.355.258.132.514.268.768.407.212-.138.459-.216.721-.216.804 0 1.455.733 1.455 1.637l-.005-.127.01.006c.054-.848.683-1.516 1.45-1.516.804 0 1.455.733 1.455 1.637 0 .588-.276 1.104-.69 1.392.826.595 1.412 1.052 1.641 1.215 1.26.896 0 2.299 0 2.3H3zm12.61 3.273c.535 0 .97.489.97 1.092 0 .602-.435 1.09-.97 1.09-.536 0-.97-.488-.97-1.09 0-.603.434-1.092.97-1.092z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Landslip')(SvgLandslip);
